import { render, staticRenderFns } from "./InitialProposalDetails.vue?vue&type=template&id=c01bc3f8"
import script from "./InitialProposalDetails.vue?vue&type=script&lang=js"
export * from "./InitialProposalDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports